export default __webpack_public_path__ + "static/media/mute.f3123064.svg";